import { Download } from "lucide-react";

import { ICampaignSummary } from "@/@types/gamification-report";
import { Button } from "components/ui/button";

import { buildSummaryCsv, downloadCsv, summaryRows } from "./report.utils";

interface ReportContentProps {
  summary: ICampaignSummary;
  campaignName: string;
}

export function ReportContent({ summary, campaignName }: ReportContentProps) {
  const handleExport = () => {
    const csv = buildSummaryCsv(summary, campaignName);
    const safeName = campaignName.replace(/[^\w-]+/g, "_").toLowerCase();
    downloadCsv(`relatorio-${safeName || "campanha"}.csv`, csv);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        {summaryRows(summary).map((row) => (
          <div key={row.label} className="rounded-lg border p-3">
            <p className="text-xs text-gray-500">{row.label}</p>
            <p className="text-lg font-semibold text-gray-800">{row.value}</p>
          </div>
        ))}
      </div>

      <div className="flex justify-end">
        <Button
          type="button"
          variant="outline"
          onClick={handleExport}
          className="gap-2"
        >
          <Download className="h-4 w-4" />
          Exportar CSV
        </Button>
      </div>
    </div>
  );
}
